import { createIcon } from "@/components/icons/createIcon";
import { twMerge } from "@/utils/twMerge";

import type { Translator } from "@/components/tiptap/EditorTranslator";
import type { DOMOutputSpec } from "@tiptap/pm/model";

export const LOCK_INDICATOR_CLASS = twMerge(
  "flex items-center justify-center w-5 h-5 rounded-md cursor-pointer",
  "text-gray-400 dark:text-gray-600",
  "[--color-icon-main:currentColor] [--color-icon-secondary:currentColor]",
  "hover:bg-blue-100 dark:hover:bg-blue-900",
  "select-none selection:bg-transparent",
);

/**
 * Static gutter lock icon; PM rebuilds this DOM freely, so the interactive
 * menu lives in LockIndicatorsOverlay and floats over it on click.
 */
export function lockIndicatorSpec(t?: Translator): DOMOutputSpec {
  const label = t ? t("lockedBlock") : "Locked block";

  return [
    "span",
    { class: "absolute inset-y-0 left-0 flex items-center select-none" },
    [
      "span",
      {
        class: twMerge("lock-indicator-static", LOCK_INDICATOR_CLASS),
        "data-lock-indicator": "",
        role: "button",
        "aria-label": label,
      },
      createIcon("LockLocked", {
        "aria-hidden": "true",
        class: "w-4 h-4 flex-shrink-0 stroke-2",
      }) ?? "🔒",
    ],
  ];
}
